import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLang } from '../LanguageContext';
import { useAuth } from '../context/AuthContext';
import { useFarm } from '../context/FarmContext';
import { getFarmOverviewPath } from '../utils/farmRoutes';

function itemsForPath(pathname, t, farmOverview) {
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length === 0) return [];
  const farmTo = farmOverview || '/';

  if (pathname === '/rooms') {
    return farmOverview ? [{ to: farmOverview, label: t('nav.farm') }] : [];
  }
  if (/^\/rooms\/[^/]+$/.test(pathname)) {
    return [];
  }
  if (pathname === '/devices') {
    return [{ to: '/devices', label: t('nav.farmGroup') }];
  }
  if (/^\/device\/[^/]+$/.test(pathname) || /^\/device\/[^/]+\/settings$/.test(pathname)) {
    const deviceBase = `/${parts[0]}/${parts[1]}`;
    return [
      { to: '/devices', label: t('nav.farmGroup') },
      { to: deviceBase, label: t('nav.devices') },
      ...(parts[2] === 'settings' ? [{ to: pathname, label: t('deviceTabs.settings') }] : []),
    ];
  }
  if (pathname === '/tasks') {
    return [{ to: '/tasks', label: t('nav.tasks') }];
  }
  if (pathname === '/admin/controllers') {
    return [
      { to: '/admin/farms', label: t('nav.adminBreadcrumb') },
      { to: '/admin/controllers', label: t('nav.allControllers') },
    ];
  }
  if (/^\/farms\/[^/]+\/overview$/.test(pathname)) {
    return [{ to: pathname, label: t('nav.farm') }];
  }
  if (pathname === '/strains') {
    return [{ to: '/strains', label: t('nav.geneticsGroup') }];
  }
  if (pathname === '/cuttings') {
    return [{ to: '/cuttings', label: t('nav.geneticsGroup') }];
  }
  return [];
}

export default function Breadcrumbs() {
  const { t } = useLang();
  const location = useLocation();
  const { token } = useAuth();
  const { effectiveFarmId } = useFarm();
  const logged = Boolean(token);

  const homeTo = useMemo(() => {
    if (logged && getFarmOverviewPath(effectiveFarmId)) {
      return getFarmOverviewPath(effectiveFarmId);
    }
    return '/';
  }, [logged, effectiveFarmId]);

  const farmOverview = getFarmOverviewPath(effectiveFarmId);
  const items = useMemo(
    () => itemsForPath(location.pathname, t, farmOverview),
    [location.pathname, t, farmOverview]
  );
  if (!items.length) return null;

  return (
    <div className="container">
      <nav aria-label="breadcrumb" className="mb-3">
        <ol className="breadcrumb shefa-breadcrumb mb-0">
          <li className="breadcrumb-item">
            <Link to={homeTo}>{t('nav.home')}</Link>
          </li>
          {items.map((item, idx) => {
            const isLast = idx === items.length - 1;
            return (
              <li
                key={`${item.to}-${idx}`}
                className={`breadcrumb-item ${isLast ? 'active' : ''}`}
                aria-current={isLast ? 'page' : undefined}
              >
                {isLast ? item.label : <Link to={item.to}>{item.label}</Link>}
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
}
